var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9556 47.8337C22.9032 47.8337 18.4998 46.1704 14.7455 42.8438C10.9911 39.5173 8.82989 35.3472 8.26172 30.3337H11.8335C12.4226 34.3633 14.2362 37.7041 17.2742 40.3559C20.3118 43.0077 23.8723 44.3337 27.9556 44.3337C32.5056 44.3337 36.3654 42.7489 39.5348 39.5795C42.7042 36.41 44.289 32.5503 44.289 28.0003C44.289 23.4503 42.7042 19.5906 39.5348 16.4212C36.3654 13.2517 32.5056 11.667 27.9556 11.667C25.4069 11.667 23.0183 12.2332 20.79 13.3657C18.5612 14.4977 16.6421 16.0554 15.0325 18.0387H21.1353V21.5387H9.28897V9.69241H12.789V15.2207C14.6825 12.9861 16.9501 11.2519 19.5918 10.0179C22.2331 8.78396 25.0211 8.16699 27.9556 8.16699C30.7078 8.16699 33.2865 8.68752 35.6918 9.72858C38.0967 10.7696 40.1936 12.1846 41.9825 13.9735C43.7714 15.7624 45.1863 17.8595 46.2274 20.2647C47.2684 22.6696 47.789 25.2482 47.789 28.0003C47.789 30.7525 47.2684 33.331 46.2274 35.7359C45.1863 38.1412 43.7714 40.2383 41.9825 42.0272C40.1936 43.816 38.0967 45.231 35.6918 46.2721C33.2865 47.3131 30.7078 47.8337 27.9556 47.8337ZM34.9603 37.3967L26.2733 28.7091V16.3337H29.7727V27.2916L37.4191 34.9373L34.9603 37.3967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.14682185a609ca486af1180396736a9f.svg";
export { ForwardRef as ReactComponent };